import importer from 'common/importer'

const scheduleAppointment = importer('Sagas/Appointments/scheduleAppointment/main')
const scheduleAppointmentSuccess = importer(
  'Sagas/Appointments/scheduleAppointment/success'
)
const scheduleAppointmentFailure = importer(
  'Sagas/Appointments/scheduleAppointment/failure'
)

const scheduleQuickAppointment = importer(
  'Sagas/Appointments/scheduleQuickAppointment/main'
)
const scheduleQuickAppointmentSuccess = importer(
  'Sagas/Appointments/scheduleQuickAppointment/success'
)
const scheduleQuickAppointmentFailure = importer(
  'Sagas/Appointments/scheduleQuickAppointment/failure'
)
//
const getAllAppointments = importer('Sagas/Appointments/getAllAppointments/main')
const getAllAppointmentsSuccess = importer(
  'Sagas/Appointments/getAllAppointments/success'
)
const getAllAppointmentsFailure = importer(
  'Sagas/Appointments/getAllAppointments/failure'
)
//
const getAppointment = importer('Sagas/Appointments/getAppointment/main')
const getAppointmentSuccess = importer('Sagas/Appointments/getAppointment/success')
const getAppointmentFailure = importer('Sagas/Appointments/getAppointment/failure')
//
const getUpcomingAppointments = importer(
  'Sagas/Appointments/getUpcomingAppointments/main'
)
const getUpcomingAppointmentsSuccess = importer(
  'Sagas/Appointments/getUpcomingAppointments/success'
)
const getUpcomingAppointmentsFailure = importer(
  'Sagas/Appointments/getUpcomingAppointments/failure'
)
//
const getAvailableSlots = importer('Sagas/Appointments/getAvailableSlots/main')
const getAvailableSlotsSuccess = importer(
  'Sagas/Appointments/getAvailableSlots/success'
)
const getAvailableSlotsFailure = importer(
  'Sagas/Appointments/getAvailableSlots/failure'
)
//
const getBookedSlots = importer('Sagas/Appointments/getBookedSlots/main')
const getBookedSlotsSuccess = importer(
  'Sagas/Appointments/getBookedSlots/success'
)
const getBookedSlotsFailure = importer(
  'Sagas/Appointments/getBookedSlots/failure'
)
//
const createNewAppointment = importer('Sagas/Appointments/createNewAppointment/main')
const createNewAppointmentSuccess = importer(
  'Sagas/Appointments/createNewAppointment/success'
)
const createNewAppointmentFailure = importer(
  'Sagas/Appointments/createNewAppointment/failure'
)
//
const validateAppointment = importer('Sagas/Appointments/validateAppointment/main')
const validateAppointmentSuccess = importer(
  'Sagas/Appointments/validateAppointment/success'
)
const validateAppointmentFailure = importer(
  'Sagas/Appointments/validateAppointment/failure'
)

//
const rescheduleAppointment = importer(
  'Sagas/Appointments/rescheduleAppointment/main'
)
const rescheduleAppointmentSuccess = importer(
  'Sagas/Appointments/rescheduleAppointment/success'
)
const rescheduleAppointmentFailure = importer(
  'Sagas/Appointments/rescheduleAppointment/failure'
)
//
const cancelAppointment = importer('Sagas/Appointments/cancelAppointment/main')
const cancelAppointmentSuccess = importer(
  'Sagas/Appointments/cancelAppointment/success'
)
const cancelAppointmentFailure = importer(
  'Sagas/Appointments/cancelAppointment/failure'
)

const newDonorBonusEligibility = importer('Sagas/Appointments/newDonorBonusEligibility/main')
const newDonorBonusEligibilitySuccess = importer('Sagas/Appointments/newDonorBonusEligibility/success')
const newDonorBonusEligibilityFailure = importer('Sagas/Appointments/newDonorBonusEligibility/failure')
//
const updateGiftCardPreference = importer('Sagas/Appointments/updateGiftCardPreference/main')
const updateGiftCardPreferenceSuccess = importer(
  'Sagas/Appointments/updateGiftCardPreference/success'
)
const updateGiftCardPreferenceFailure = importer(
  'Sagas/Appointments/updateGiftCardPreference/failure'
)

export default {
  scheduleAppointment,
  scheduleAppointmentSuccess,
  scheduleAppointmentFailure,

  scheduleQuickAppointment,
  scheduleQuickAppointmentSuccess,
  scheduleQuickAppointmentFailure,

  getAllAppointments,
  getAllAppointmentsSuccess,
  getAllAppointmentsFailure,

  getAppointment,
  getAppointmentSuccess,
  getAppointmentFailure,

  rescheduleAppointment,
  rescheduleAppointmentSuccess,
  rescheduleAppointmentFailure,

  cancelAppointment,
  cancelAppointmentSuccess,
  cancelAppointmentFailure,

  /* NEW */

  getUpcomingAppointments,
  getUpcomingAppointmentsSuccess,
  getUpcomingAppointmentsFailure,

  getAvailableSlots,
  getAvailableSlotsSuccess,
  getAvailableSlotsFailure,

  getBookedSlots,
  getBookedSlotsSuccess,
  getBookedSlotsFailure,

  createNewAppointment,
  createNewAppointmentSuccess,
  createNewAppointmentFailure,

  validateAppointment,
  validateAppointmentSuccess,
  validateAppointmentFailure,

  newDonorBonusEligibility,
  newDonorBonusEligibilitySuccess,
  newDonorBonusEligibilityFailure,
  
  updateGiftCardPreference,
  updateGiftCardPreferenceSuccess,
  updateGiftCardPreferenceFailure
}
